"use strict";
exports.__esModule = true;
var parseSelector = function (selector) {
    var _a, _b;
    var config = {};
    var $selector, methods, attr;
    if (Array.isArray(selector)) {
        return { selector: selector.join(', ') };
    }
    if (typeof selector !== 'string') {
        return selector;
    }
    if (selector === null || selector === void 0 ? void 0 : selector.includes('|')) {
        _a = selector.split('|').map(function (key) { return key.trim(); }), $selector = _a[0], methods = _a.slice(1);
        methods === null || methods === void 0 ? void 0 : methods.map(function (p) { return p.trim(); });
    }
    if (!$selector) {
        $selector = selector;
    }
    if ($selector === null || $selector === void 0 ? void 0 : $selector.includes('@')) {
        _b = $selector.split('@').map(function (key) { return key.trim(); }), $selector = _b[0], attr = _b[1];
    }
    if ($selector)
        config.selector = Array.isArray($selector)
            ? $selector.join(', ')
            : $selector;
    if (attr)
        config.attr = attr;
    if (methods === null || methods === void 0 ? void 0 : methods.length) {
        if (methods.includes('array')) {
            config.type = 'array';
        }
        config.methods = methods.filter(function (i) { return i !== 'array'; });
    }
    return config;
};
exports["default"] = parseSelector;
